import { Grid, IconButton, Tooltip } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import DeleteIcon from '@mui/icons-material/Delete'

import { colours } from '../settings/settings'

const GridIconButton = ({
  type,
  disabled,
  transparent,
  size = 'grow',
  noCenter,
  iconSize,
  onClick,
  text,
}) => {
  if (transparent) disabled = true

  let title
  if (type === 'add') title = 'Aggiungi'
  if (type === 'edit') title = 'Modifica'
  if (type === 'save') title = 'Salva'
  if (type === 'clear') title = 'Annulla'
  if (type === 'delete') title = 'Elimina'

  let Icon
  if (type === 'add') Icon = AddIcon
  if (type === 'edit') Icon = EditIcon
  if (type === 'save') Icon = SaveIcon
  if (type === 'clear') Icon = ClearIcon
  if (type === 'delete') Icon = DeleteIcon

  let color
  if (type === 'add') color = colours.black
  if (type === 'edit') color = colours.blueDark
  if (type === 'save') color = colours.blueDark
  if (type === 'clear') color = colours.red
  if (type === 'delete') color = colours.red

  if (!iconSize) iconSize = type === 'add' || text ? 'medium' : 'small'

  const centerStyle = noCenter
    ? {}
    : { display: 'flex', justifyContent: 'center', alignItems: 'center' }

  const transparentProps = transparent
    ? { style: { color: 'transparent', backgroundColor: 'transparent' } }
    : {}

  return (
    <Grid size={size}>
      <div style={centerStyle}>
        <IconButton
          size={iconSize}
          style={{ color }}
          onClick={onClick}
          disabled={!!disabled}
          {...transparentProps}
        >
          {text ? (
            <>
              <Icon size={iconSize} />
              &nbsp;{text}
            </>
          ) : (
            <Tooltip title={title}>
              <Icon size={iconSize} />
            </Tooltip>
          )}
        </IconButton>
      </div>
    </Grid>
  )
}

export default GridIconButton
